import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import EditIcon from '@/components/Icons/EditIcon';
import PlusIcon from '@/components/Icons/PlusIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import useFilter from '@/hooks/useFilter';
import { IDeptResponse } from '@/interfaces/attendance.model';
import {
  IDeleteResponse,
  IFilterSideBarForm,
  IPageInfo,
} from '@/interfaces/common.model';
import { IDepartmentList } from '@/interfaces/department.model';
import { IDesignation } from '@/interfaces/designation.mode';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import { RootState } from '@/redux/store';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
interface ITableData {
  id: string;
  index: number;
  designation: string;
  toggleStatus: boolean;
  canAccessTeam: boolean;
  level: number;
  department: string;
}
interface IDesignationFilter {
  departmentList: IDepartmentList[];
}
export interface IDesignationResponse {
  status: boolean;
  message: string;
  data: { designation: IDesignation[]; pageInfo: IPageInfo };
}
export interface IpageStates extends IPageInfo {
  [key: string]: string | number | boolean | ITableData[] | undefined;
  count: number;
  tableLoader: boolean;
  designation: ITableData[];
  filterData: string;
  searchQuery: string;
}
const Designation: React.FC = () => {
  const dispatch = useDispatch();
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const [pageStates, setPageStates] = useState<IpageStates>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    designation: [],
    filterData: '',
    searchQuery: '',
  });
  const [filter, setFilter] = useState<IDesignationFilter>({
    departmentList: [],
  });
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const navigate = useNavigate();

  const handleUpdate = (data: ITableData) => {
    navigate(RoutesLink.addDesignation, { state: { data: data } });
  };
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'designation', label: 'Designation' },
    { value: 'department', label: 'Department' },
    { value: 'canAccessTeam', label: 'Can Access Team' },
    { value: 'level', label: 'Level' },
    { value: 'toggleStatus', label: 'Status' },
  ];
  const actionData = [
    {
      label: 'Edit',
      className: 'btn btn-link',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: handleUpdate,
    },
    // {
    //   label: 'Delete',
    //   className: 'btn btn-link',
    //   icon: <DeleteIcon />,
    //   title: 'delete',
    //   clickHandler: deleteActionHandler,
    // },
  ];
  useEffect(() => {
    getDepartment();
  }, []);
  // const handleDelete = async () => {
  //   setIsLoading(true);
  //   const response: IDeleteResponse = await callApi(
  //     API_URL + API_ENDPOINT.deleteShift + +`?shiftId=${selectedId}`,
  //     {
  //       method: 'GET',
  //     },
  //   );
  //   setIsLoading(false);
  //   if (response?.status) {
  //     showToastNotification('success', response?.message);
  //     // getShift();
  //   } else {
  //     showToastNotification('danger', response?.message);
  //   }
  //   toggle();
  // };
  const getDesignations = async () => {
    try {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: true,
      }));
      const filter = {
        search: pageStates.searchQuery,
        pageSize: filterDetails?.pageSize,
        pageNumber: pageStates.currentPage,
        departmentId: filterDetails?.department,
      };
      const API = `${API_URL}${API_ENDPOINT?.getDesigantion}?${getFilterUrl(filter)}`;
      const response: IDesignationResponse = await callApi(API, {
        method: 'GET',
      });
      if (response.status) {
        const newData: ITableData[] = response?.data?.designation?.map(
          (item, index) => ({
            ...item,
            index: index + 1,
            designation: item?.name,
            toggleStatus: item.isActive,
            canAccessTeam: item?.canAccessTeam,
            level: item?.level,
            department: item?.department?.name ?? '',
          }),
        );
        setPageStates((prev) => ({
          ...prev,
          designation: newData,
          tableLoader: false,
          totalPages: response?.data?.pageInfo?.totalPages,
          count: response?.data?.pageInfo?.total ?? 0,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  };
  const { pageChangeHandler, handleSearchChange, handleChangePageSize } =
    useFilter(pageStates, setPageStates);
  useEffect(() => {
    getDesignations();
  }, [
    filterDetails?.pageSize,
    pageStates?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.department,
  ]);
  const handleStatusToggle = async (
    data: ITableData,
    status: boolean,
    heading?: string | number,
  ) => {
    let postData = {};
    if (heading == 'toggleStatus') {
      const updatedDesignation = pageStates.designation?.map((des) => {
        if (des.id === data.id) {
          return {
            ...des,
            toggleStatus: !status,
            isActive: !status,
          };
        }
        return des;
      });
      setPageStates((prev) => ({
        ...prev,
        designation: updatedDesignation,
      }));
      postData = {
        ...data,
        isActive: !data?.toggleStatus,
      };
    } else {
      const updatedDesignation = pageStates.designation?.map((des) => {
        if (des.id === data.id) {
          return {
            ...des,
            canAccessTeam: !status,
          };
        }
        return des;
      });
      setPageStates((prev) => ({
        ...prev,
        designation: updatedDesignation,
      }));
      postData = { ...data, canAccessTeam: !data?.canAccessTeam };
    }

    try {
      const response: IDeleteResponse = await callApi(
        API_URL + API_ENDPOINT.updateDesignation + `?designationId=${data?.id}`,
        {
          method: 'POST',
          data: postData,
        },
      );
      if (response?.status) {
        showToastNotification('success', response?.message);
        // getDesignations();
      }
    } catch (error) {
      if (heading == 'toggleStatus') {
        const updatedDesignation = pageStates.designation?.map((des) => {
          if (des.id === data.id) {
            return {
              ...des,
              toggleStatus: status,
            };
          }
          return des;
        });
        setPageStates((prev) => ({
          ...prev,
          designation: updatedDesignation,
        }));
      } else {
        const updatedDesignation = pageStates.designation?.map((des) => {
          if (des.id === data.id) {
            return {
              ...des,
              canAccessTeam: status,
            };
          }
          return des;
        });
        setPageStates((prev) => ({
          ...prev,
          designation: updatedDesignation,
        }));
      }
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };

  const getDepartment = async () => {
    const deptRes: IDeptResponse = await callApi(
      API_URL + API_ENDPOINT.getDepartment,
      { method: 'GET' },
    );
    if (deptRes?.status === true) {
      const departments = deptRes.data.department;
      setFilter((pre) => ({
        ...pre,
        departmentList: departments,
      }));
    }
  };

  const attendanceSortList = {
    department: filter?.departmentList,
  };
  const handleData = (
    data: Partial<IFilterSideBarForm> | null,
    type?: string | null,
  ) => {
    if (type == null) {
      dispatch(
        setUpdateFilterStates({
          department: String(data?.department ?? ''),
          currentPage: 1,
        }),
      );
      setPageStates((prev) => ({ ...prev, currentPage: 1 }));
    }
  };

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Designations'}
            buttonText={'Add Designations'}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink.addDesignation}
          />
          <CardLayout isGrid={tableView === 'grid'}>
            <FilterComponent
              handleSearch={handleSearchChange}
              filterArray={{
                isShow: true,
              }}
              isGrid={false}
              attendanceSortList={attendanceSortList}
              sortHandler={handleData}
            />
            <CommonTable<ITableData>
              handleStatusToggle={handleStatusToggle}
              ActionData={actionData}
              pageChangeHandler={pageChangeHandler}
              tableHeading={tableHeading}
              tableData={pageStates?.designation}
              currentPage={pageStates?.currentPage}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates.totalPages}
              count={pageStates.count}
              pageSize={filterDetails.pageSize}
              handleChangePageSize={handleChangePageSize}
            />
          </CardLayout>
        </div>
      </Layout>
      {/* <ConfirmModal
        isOpen={isConfirModal}
        toggle={toggle}
        submitHandler={() => {}}
        isLoading={isLoading}
      /> */}
    </>
  );
};
export default Designation;
